"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadioButton = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../../../../../themes");
var mixins_1 = require("../../../../../../../themes/mixins");
var baseStyling_1 = require("../../../../../../themes/utils/baseStyling");
var red = themes_1.colors.red, white = themes_1.colors.white, grey2 = themes_1.colors.grey2, grey5 = themes_1.colors.grey5, grey10 = themes_1.colors.grey10, grey20 = themes_1.colors.grey20, grey80 = themes_1.colors.grey80;
exports.StyledRadioButton = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  width: 2.4rem;\n  height: 2.4rem;\n  ", "{\n    width: 1.8rem;\n    height: 1.8rem;\n  }\n  border-radius: 50%;\n  cursor: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  background: ", ";\n  border: ", ";\n\n  &:hover {\n    ", "\n  }\n\n  /* &:focus {\n    outline: none;\n    box-shadow: ", ";\n  } */\n\n  /* add the smaller circle for selected state */\n  &::after {\n    z-index: 1; //so that the black overlay that appears via ::before is below this\n    content: \"\";\n    position: absolute;\n    width: 1.4rem;\n    height: 1.4rem;\n    ", "{\n      width: 1rem;\n      height: 1rem;\n    }\n    border-radius: 50%;\n    background-color: ", ";\n    border: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  position: relative;\n  width: 2.4rem;\n  height: 2.4rem;\n  ", "{\n    width: 1.8rem;\n    height: 1.8rem;\n  }\n  border-radius: 50%;\n  cursor: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  background: ", ";\n  border: ", ";\n\n  &:hover {\n    ", "\n  }\n\n  /* &:focus {\n    outline: none;\n    box-shadow: ", ";\n  } */\n\n  /* add the smaller circle for selected state */\n  &::after {\n    z-index: 1; //so that the black overlay that appears via ::before is below this\n    content: \"\";\n    position: absolute;\n    width: 1.4rem;\n    height: 1.4rem;\n    ", "{\n      width: 1rem;\n      height: 1rem;\n    }\n    border-radius: 50%;\n    background-color: ", ";\n    border: ", ";\n    box-shadow: ", ";\n  }\n"])), (0, mixins_1.mediaQuery)('md'), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "not-allowed" : "pointer");
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    return isSelected && !disabled && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", " \n  "], ["\n    ", " \n  "])), (0, baseStyling_1.applyBlackOverlayOnHover)());
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled, theme = _a.theme;
    if (isSelected) {
        return disabled ? grey5 : grey80;
    }
    return disabled ? grey5 : "none";
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    if (isSelected) {
        return disabled ? "1px solid ".concat(grey20) : "white";
    }
    return disabled ? "1px solid ".concat(grey10) : "1px solid ".concat(grey20);
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    return !disabled &&
        !isSelected && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), baseStyling_1.borderStyleOnHover);
}, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected ? "0px 4px 6px rgba(0, 0, 0, 0.25)" : "none";
}, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    return isSelected ? white : disabled ? "none" : "none";
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled, theme = _a.theme;
    return isSelected
        ? disabled
            ? "1px solid ".concat(grey20)
            : "1px solid ".concat(grey80)
        : "none";
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    return isSelected && !disabled ? "0px 4px 6px rgba(0, 0, 0, 0.25)" : "none";
});
var templateObject_1, templateObject_2, templateObject_3;
// we no longer need StyleRadioInputFill since the ::after pseudo is doing the work. It wasn't working without it.
// export const StyledRadioInputFill = styled.div`
//   width: ${({ isSelected }) => (isSelected ? '10px' : '0px')};
//   height: ${({ isSelected }) => (isSelected ? '10px' : '0px')};
//   border-radius: 50%;
//   background: ${({ isSelected, disabled }) => {
//     if (isSelected) {
//       return disabled ? 'rgba(0, 0, 0, 0.1)' : white; /* White for selected, light gray for disabled */
//     }
//     return 'transparent';
//   }};
//   border: ${({ isSelected, disabled }) => {
//     if (isSelected) {
//       return disabled ? '1px solid rgba(0, 0, 0, 0.2)' : `1px solid ${onSecondary}`; /* Dark border for selected */
//     }
//     return 'none';
//   }};
//   box-shadow: ${({ isSelected, disabled }) =>
//     isSelected && !disabled ? '0px 4px 6px rgba(0, 0, 0, 0.25)' : 'none'};
// `;
